import React from 'react';
// This component now relies on the 'xlsx' library to generate an Excel file.
// Please ensure it's added to your project's dependencies (e.g., `npm install xlsx`).
// If you're not using a bundler, you may need to include it via a script tag in your HTML:
// <script src="https://cdn.sheetjs.com/xlsx-latest/package/dist/xlsx.full.min.js"></script>
import * as XLSX from 'xlsx';

const SampleFileDownloader = () => {
    const handleDownload = () => {
        // Headers must match the backend parser's expectations.
      const headers = [
            'provider','renderingFacility','taxId','ptName', 'dob', 'ssn', 'employer', 'insurance', 
            'bill', 'paid', 'outstanding', 'ledger', 'hcf', 'invoice', 'signinSheet',
            'fds', 'lds', 'solDate',
            'hearingStatus', 'hearingDate', 'hearingTime', 'judgeName','courtRoomlink','judgePhone','AccesCode','boardLocation',
            'lienStatus', 'caseStatus', 'caseDate', 'crAmount', 'dorFiledBy', 'status4903_8', 'pmrStatus', 'judgeOrderStatus', 'adjuster', 'adjusterPhone',
            'adjusterFax', 'adjusterEmail', 'defenseAttorney', 'defenseAttorneyPhone',
            'defenseAttorneyFax', 'defenseAttorneyEmail',
            'claimNo.1', 'claimNo.2',
            'adjNumber.1', 'adjNumber.2',
            'doi.1', 'doi.2'
        ];

        // --- FIX: Change date formats to MM/DD/YYYY to match user description ---
       const exampleRow = [
            'MMCK','Medical Facilities of America (MFA)','85-2240442','John Patient', '01/15/1990', '123-45-6789', 'Some Company', 'Health Insurer', 
            '1250.75', '250.00', '1000.75', 'yes', 'no', 'not required', 'yes',
            '01/10/2023', '02/15/2023', '01/10/2025',
            'Pending', '11/20/2024', 'AM', 'Judge Smith','http://localhost:3000/admin','555-002-0001','782549','Main Courthouse', 'Filed', 'SETTLED', '03/01/2023', '5000', // MODIFIED: Updated caseStatus example
            'HUBUR','yes','no','PENDING','Jane Adjuster', '555-001-0001', '555-001-0002', 'jane.a@example.com',
            'Bob Attorney', '555-002-0001', '555-002-0002', 'bob.l@example.com',
            'ABC-123', 'DEF-456',
            'ADJ-XYZ-1', 'ADJ-XYZ-2',
            '01/10/2023', '01/11/2023'
        ];
        // --- END FIX ---

        // --- Generate XLSX file ---
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet([headers, exampleRow]);

        // --- FIX: Force date/time columns to be treated as Text (@) in Excel ---
        // This prevents Excel from auto-reformatting them on download.
        // The 'z' key sets the number format. '@' is the format code for 'Text'.
        const textFormat = '@';
        const dateCols = ['E', 'P', 'Q', 'R', 'T', 'AA', 'AJ', 'AK']; // Columns for dates and DOI
        const timeCols = ['U']; // Column for time
        // MODIFIED: Added 'Z' (caseStatus) to text format to be safe
        const textCols = ['Z']; 

        dateCols.forEach(col => {
            const cellRef = `${col}2`; // Apply to row 2 (the data row)
            if (ws[cellRef]) {
                ws[cellRef].t = 's'; // Set type to string
                ws[cellRef].z = textFormat; // Set format to Text
            }
        });
        
        timeCols.forEach(col => {
             const cellRef = `${col}2`;
             if (ws[cellRef]) {
                 ws[cellRef].t = 's';
                 ws[cellRef].z = textFormat;
             }
        });

        // NEW: Apply text format to caseStatus column
        textCols.forEach(col => {
             const cellRef = `${col}2`;
             if (ws[cellRef]) {
                 ws[cellRef].t = 's';
                 ws[cellRef].z = textFormat;
             }
        });
        // --- END FIX ---


        XLSX.utils.book_append_sheet(wb, ws, "Sample Records");
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

        // Create a Blob object with the correct MIME type for an XLSX file.
        const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Create a temporary link to trigger the file download.
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'sample_records.xlsx'); // Filename changed to .xlsx
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    return (
        <div className="text-right mt-1">
            <button
                type="button"
                onClick={handleDownload}
                className="text-sm text-indigo-600 hover:text-indigo-800 font-medium hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
                Download Sample Template (.xlsx)
            </button>
        </div>
    );
};

export default SampleFileDownloader;
